export var EMPTY_ONSITE_MESSAGE_WRAPPER = 'EmptyOnsiteMessage';
export var DSP_BRAND = 'zillow';
export var DSP_EXPERIENCE = 'onsite_message';
export var MAX_EVENT_VALUE_LENGTH = 20;
export var EVENT_KEY_MAPPING = {
  skipDisplayReason: 'skip_display_reason_txt',
  shouldDisplay: 'should_display_ind',
  isGlobalHoldout: 'global_holdout_ind',
  isPlacementHoldout: 'placement_holdout_ind',
  placementName: 'placement_nm',
  testPhase: 'test_phase_nm',
  bucket: 'bucket_nm',
  placementId: 'placement_id',
  passThrottle: 'throttle_pass_ind',
  lastModified: 'last_modified_dtm',
  eventId: 'event_id',
  decisionContextguid: 'decision_context_guid',
  decisionContextencodedZuid: 'decision_context_encoded_zuid',
  selectedTreatmentid: 'selected_treatment_id',
  selectedTreatmentname: 'selected_treatment_nm',
  selectedTreatmentstatus: 'selected_treatment_status_cd',
  selectedTreatmentlastModified: 'selected_treatment_last_modified_dtm',
  selectedTreatmentlineOfBusiness: 'selected_treatment_lob_nm',
  selectedTreatmentexperimentFamily: 'selected_treatment_experiment_family_nm',
  selectedTreatmentexperimentIteration: 'selected_treatment_experiment_iteration_txt',
  selectedTreatmenttreatmentVariation: 'selected_treatment_variation_nm',
  qualifiedTreatmentsPORTFOLIO: 'qualified_treatment_portfolio_nm',
  qualifiedTreatmentsPORTFOLIO_TEST: 'qualified_treatment_portfolio_test_nm',
  qualifiedTreatmentsTARGET_SELECTION: 'qualified_treatment_target_selection_nm',
  qualifiedTreatmentsBASELINE_EVALUATION: 'qualified_treatment_baseline_evaluation_nm',
  isZHLEligible: 'is_zhl_eligible',
  isUserGeoInZHLGoBigMarket: 'is_user_geo_in_zhl_go_big_market',
  isNBASelectionApplied: 'is_nba_selection_applied',
  // NBA fields
  nbaJoiningId: 'joining_uuid',
  nbaServiceErrorInd: 'service_error_ind',
  nbaServiceErrorTxt: 'service_error_txt',
  isFallbackActionRankingUsed: 'fallback_action_ranking_used_ind',
  isUserImpressionReported: 'user_impression_reported_ind'
};